import angular from 'angular';

import AdMarkupService from './service';

angular.module('generator.dsp.adMarkup', [
  'generator.creativePreview',
  'generator.shared'
]);

angular
  .module('generator.dsp.adMarkup')
  .service('AdMarkupService', AdMarkupService);
